/**
 * @documental
 * @export Placeholder
 * @name
 * MultiSelectDropdown.Placeholder
 */

import { FC } from "react";
import Skeleton from "react-loading-skeleton";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { InputContainerPlaceholder } from "../shared/InputContainer/InputContainerPlaceholder";
import styles from "./styles.module.scss";

/**
 * The `Placeholder` component properties.
 */

export interface PlaceholderProps extends BaseProps {}

/**
 * A loading placeholder for the `MultiSelectDropdown` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.MultiSelectDropdownPlaceholder, "multi-select-dropdown", "placeholder"],
    testIdPrefix: "multi-select-dropdown",
  });

  return (
    <InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)}>
      <div className={styles.PlaceholderMultiSelectDropdown}>
        <Skeleton />
      </div>
    </InputContainerPlaceholder>
  );
};
